export default __webpack_public_path__ + "static/media/Mobile_Grudge_Effect.72a4c662.svg";